class PolicyEmitted {
    constructor(id, proposal, policyNumber, additionalData, requiresInspection = true, requiresApproval) {
        this.id = id
        this.proposal = proposal
        this.policyNumber = policyNumber
        this.additionalData = additionalData
        this.requiresInspection = requiresInspection
        this.requiresApproval = requiresApproval
    }

    static fromJson({ id, proposal, policyNumber, additionalData, requiresInspection, requiresApproval }) {
        return new PolicyEmitted(id, proposal, policyNumber, additionalData, requiresInspection, requiresApproval)
    }
}

export default PolicyEmitted
